<div class="avatar">
    <div
        class="avatar__select"
        #avatarSelect
        tabindex="0"
        [ngClass]="editable ? 'clickable' : ''"
        (click)="editable ? toggleSelector() : false"
        (keyup.enter)="editable ? toggleSelector() : false"
        (keyup)="editable ? navigateCustomKeys($event) : false"
        i18n-aria-label="@@button-change-avatar"
        aria-label="Change Avatar"
        role="combobox"
        aria-controls="avatar__select-menu"
        [attr.aria-expanded]="showSelector"
        data-testid="cy-avatar-selector">
        <mat-icon
            class="riege-icon avatar__emoji"
            [svgIcon]="avatarImage"
            data-testid="cy-avatar-selectored-emoji"></mat-icon>
        <mat-icon class="riege-icon avatar__edit">edit</mat-icon>

        <ng-container *ngIf="editable">
            <div
                id="avatar__select-menu"
                class="avatar__select-menu"
                *ngIf="showSelector"
                data-testid="cy-avatar-selector-menu">
                <mat-icon
                    [svgIcon]="emoji"
                    *ngFor="let emoji of emojis; let i = index"
                    [attr.data-index]="i"
                    class="riege-icon emoji-menu__item emoji--xl"
                    [tabindex]="avatarImage === emoji ? -1 : 0"
                    [ngClass]="{ 'emoji-menu__item--active': avatarImage === emoji }"
                    (click)="avatarImage === emoji ? '' : selectAvatar(emoji)"
                    (keyup.enter)="avatarImage === emoji ? '' : selectAvatar(emoji)"
                    (keyup)="editable ? navigateCustomKeys($event) : false"></mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="avatar__caption" i18n="@@msg-choose-avatar">Choose your avatar</div>
</div>
